import { render } from "./Bienes.vue?vue&type=template&id=862f9bce&scoped=true"
import script from "./Bienes.vue?vue&type=script&lang=js"
export * from "./Bienes.vue?vue&type=script&lang=js"

import "./Bienes.vue?vue&type=style&index=0&id=862f9bce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-862f9bce"]])

export default __exports__